module.exports = __webpack_public_path__ + "img/pr-10.a2a83731.png";